import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './Components/Home';
import Footers from './Components/Footers';
import DigitalOfficeFramework from './Components/digitalPage';
import TRACeGRC from './Components/tracePage';
import ScrollToTop from './Components/scroll';
import FinancialAccounting from './Components/financial';
import DocAssist from './Components/docAssist';
import Edict from './Components/edict';
import TRACe from './Components/traceGRC';
import CLACT from './Components/clact';
import DocAssistProduct from './Components/docAssistProduct';
import Press from './Components/press';



function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route exact path='/' element={<HomePage />} />
          <Route exact path='/digital-office-framework' element={<DigitalOfficeFramework />} />
          <Route exact path='/trace-grc' element={<TRACeGRC />} />
          <Route exact path='/finanacial-accountant' element={<FinancialAccounting />} />
          <Route exact path='/doc-assist' element={<DocAssist />} />
          <Route exact path='/edict' element={<Edict />} />
          <Route exact path='/traceGRC' element={<TRACe />} />
          <Route exact path='/clact' element={<CLACT />} />
          <Route exact path='/docAssist-product' element={<DocAssistProduct />} />
          <Route exact path='/press' element={<Press />} />
        </Routes>
      </Router>
      <Footers />
    </>
  );
}

export default App;
